import React from "react";
import { isEmpty, omitBy, isUndefined, trim } from "lodash";

export function customVariables(attributes) {
	const { ghubPlayIconColor, ghubPlayButtonSize, ghubPlayIconBgColor } =
		attributes;

	let styles = {
		"--ghub-play-icon-color": ghubPlayIconColor,
		"--ghub-play-icon-bg-color": ghubPlayIconBgColor,
		"--ghub-play-icon-size": ghubPlayButtonSize,
	};

	return omitBy(styles, (value) => {
		return (
			isUndefined(value) ||
			value === false ||
			trim(value) === "" ||
			isEmpty(value)
		);
	});
}
